import { configureStore } from '@reduxjs/toolkit'
import {
  FAMILY_CACHE_PURGE_INTERVAL_MS,
  familySlice,
  purgeExpiredBeveragesCache,
  purgeExpiredDiaryTypeCache,
  purgeExpiredDiaryTypesCache,
  purgeExpiredGrowthMeasuresCache,
  purgeExpiredIllnessesCache,
  purgeExpiredMedicinesCache,
  purgeExpiredVaccinesCache,
  purgeExpiredVisitTypesCache,
} from './slices/family'

export const store = configureStore({
  reducer: {
    family: familySlice.reducer,
  },
})

if (import.meta.env.DEV) {
  store.subscribe(() => {
    console.log('[store-family]', store.getState().family)
  })
}

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

if (typeof window !== 'undefined') {
  window.setInterval(() => {
    store.dispatch(purgeExpiredVisitTypesCache())
    store.dispatch(purgeExpiredIllnessesCache())
    store.dispatch(purgeExpiredMedicinesCache())
    store.dispatch(purgeExpiredBeveragesCache())
    store.dispatch(purgeExpiredVaccinesCache())
    store.dispatch(purgeExpiredDiaryTypesCache())
    store.dispatch(purgeExpiredDiaryTypeCache())
    store.dispatch(purgeExpiredGrowthMeasuresCache())
  }, FAMILY_CACHE_PURGE_INTERVAL_MS)
}
